import React from 'react';
import { motion } from 'framer-motion';
import { Droplets, Thermometer, CloudLightning, Wrench } from 'lucide-react';

const problems = [
  { icon: Droplets, title: 'Infiltrazioni d\'acqua', desc: 'Macchie di umidita, muffa e danni strutturali che peggiorano col tempo. Ogni giorno senza intervento aumenta i costi.' },
  { icon: Thermometer, title: 'Dispersione termica', desc: 'D\'estate un forno, d\'inverno il freddo entra. Bollette energetiche alle stelle per un isolamento inadeguato.' },
  { icon: CloudLightning, title: 'Danni da grandine', desc: 'Tegole rotte, crepe, infiltrazioni improvvise. Ogni temporale diventa una fonte di preoccupazione e spesa.' },
  { icon: Wrench, title: 'Manutenzione continua', desc: 'Rattoppi che non durano, interventi ripetuti, preventivi con ponteggi che raddoppiano i costi.' },
];

const fadeUp = { hidden: { opacity: 0, y: 24 }, visible: (i) => ({ opacity: 1, y: 0, transition: { duration: 0.5, delay: i * 0.1 } }) };

const ProblemSection = () => (
  <section className="py-24 md:py-32 bg-white">
    <div className="max-w-7xl mx-auto px-6 md:px-8">
      <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5 }} className="text-center mb-16">
        <span className="text-[#FF5722] text-sm font-semibold uppercase tracking-wider">Il problema</span>
        <h2 className="text-3xl sm:text-4xl font-semibold tracking-tight text-slate-900 mt-3">Stanco di rattoppi che non funzionano?</h2>
        <p className="mt-4 text-slate-500 max-w-2xl mx-auto">Ogni anno migliaia di proprietari sprecano soldi in riparazioni temporanee. Noi offriamo soluzioni definitive.</p>
      </motion.div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {problems.map((problem, i) => (
          <motion.div key={problem.title} custom={i} initial="hidden" whileInView="visible" viewport={{ once: true }} variants={fadeUp} className="bg-white border border-slate-200 rounded-2xl p-6 hover:border-[#FF5722]/30 hover:shadow-lg hover:shadow-[#FF5722]/5 transition-all duration-300 hover:-translate-y-1 group">
            <div className="w-12 h-12 bg-[#FF5722]/10 rounded-xl flex items-center justify-center mb-4 group-hover:bg-[#FF5722]/15 transition-colors">
              <problem.icon className="w-6 h-6 text-[#FF5722]" />
            </div>
            <h3 className="text-lg font-semibold text-slate-900 mb-2">{problem.title}</h3>
            <p className="text-sm text-slate-500 leading-relaxed">{problem.desc}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default ProblemSection;
